import React, { Component } from 'react';

import './style.css';


export default class FormSubmitAgreement extends Component {
  render() {
    return (
      <span className='form__additional form__additional_agree-to-process-info'>
        Нажимая на&nbsp;кнопку, Вы соглашаетесь на&nbsp;обработку персональных&nbsp;данных. Ознакомьтесь с&nbsp;
        <a
          className='form__additional form__additional_link'
          href='https://drive.google.com/file/d/0B0enOOPZ0QwoUUh6WVhhR1VHZGM/view'
          target='_blank'
          alt='agreement'
        >Политикой&nbsp;в&nbsp;отношении&nbsp;обработки&nbsp;данных</a>
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/blocks/form-blocks/FormSubmitAgreement.js